import * as React from 'react';

interface IconProps {
	isHovered: boolean;
	size?: number;
}

export function ArchiveIcon({ isHovered, size = 24 }: IconProps) {
	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<style>
				{`
					@keyframes archiveRect {
						0% { transform: translateY(0px); }
						50% { transform: translateY(-1.5px); }
						100% { transform: translateY(0px); }
					}
					@keyframes archivePath {
						0% { d: path('M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8'); }
						50% { d: path('M4 11v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V11'); }
						100% { d: path('M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8'); }
					}
					@keyframes archiveSecondaryPath {
						0% { d: path('M10 12h4'); }
						50% { d: path('M10 15h4'); }
						100% { d: path('M10 12h4'); }
					}
					.archive-rect {
						animation: ${isHovered ? 'archiveRect 0.6s ease-in-out infinite' : 'none'};
					}
					.archive-path {
						animation: ${isHovered ? 'archivePath 0.6s ease-in-out infinite' : 'none'};
					}
					.archive-secondary-path {
						animation: ${isHovered ? 'archiveSecondaryPath 0.6s ease-in-out infinite' : 'none'};
					}
				`}
			</style>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width={size}
				height={size}
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				style={{ overflow: 'visible' }}
			>
				<rect
					className='archive-rect'
					width='20'
					height='5'
					x='2'
					y='3'
					rx='1'
				/>
				<path
					className='archive-path'
					d='M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8'
				/>
				<path className='archive-secondary-path' d='M10 12h4' />
			</svg>
		</div>
	);
}
